import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  giftCardToken: attr(String),
  giftCardPanSuffix: attr(String)
});